import classes from './NotFoundContainer.module.css';
import PropTypes from 'prop-types';

export default function NotFoundContainer({ children }) {
  return <section className={classes.container}>{children}</section>;
}

NotFoundContainer.propTypes = {
  children: PropTypes.node.isRequired
};